// extracted by mini-css-extract-plugin
export default {"swiper":"News_swiper__h8AZG","swiper__container":"News_swiper__container__MM5sD","swiper__slide":"News_swiper__slide__vvNNQ"};